export default __webpack_public_path__ + "static/media/rating_active_3.890036d6.png";